import {styled} from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

const Button = styled(MuiButton)(() => ({
    textTransform: "none",
}));

const formatDate = (date) => {
    return date.format("YYYY-MM-DD");
};

const AwardsDateFilters = ({filters, updateFilters}) => {

    const updateEffectiveFromDate = (value) => {
        filters.fromEffectiveDate = formatDate(value);
        updateFilters();
    };

    const updateEffectiveToDate = (value) => {
        filters.toEffectiveDate = formatDate(value);
        updateFilters();
    };

    const selectMonthRange = (value) => {
        const end = dayjs();
        const start = end.subtract(value, "month").add(1, "day");

        filters.fromEffectiveDate = formatDate(start);
        filters.toEffectiveDate = formatDate(end);

        updateFilters();
    };

    return (
        <Grid container direction="row" spacing={{xs: 0, sm: 2}} sx={{justifyContent: {xs: "center", sm: "right"}, alignItems: 'center'}}>
            <Grid columns={{xs: 12, sm: 6}}>
                <Button variant="text" onClick={() => selectMonthRange(12)}>12 Months</Button>
                <Button variant="text" onClick={() => selectMonthRange(6)}>6 Months</Button>
                <Button variant="text" onClick={() => selectMonthRange(3)}>3 Months</Button>
            </Grid>
            <Grid columns={{xs: 12, sm: 6}}>
                <DatePicker
                    value={dayjs(filters.fromEffectiveDate)}
                    onChange={updateEffectiveFromDate}
                    slotProps={{textField: {size: 'small'}}}
                />
                <DatePicker
                    onChange={updateEffectiveToDate}
                    value={dayjs(filters.toEffectiveDate)}
                    slotProps={{textField: {size: 'small'}}}
                />
            </Grid>
        </Grid>
    );
};

export default AwardsDateFilters;
